import { Dialog, DialogContent, DialogHeader, DialogTitle } from "components/app/dialog/dialog";
import NumberInput from "components/app/function/NumberInput";
import { ScrollArea, ScrollBar } from "components/ui/scroll-area";

import { ArrowLeft, ChevronRight, Loader, X } from "lucide-react";

import Reports from "pages/news-feed/dummyReport";
import { useState } from "react";

import { AppLog } from "services";
import appStore from "store/appStore";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";
import { Service } from "utils/services";

interface DialogProps {
  post: any;
  isDialogOpen: boolean;
  setIsDialogOpen: (value: boolean) => void;
}
export default function NewFeedDialogReportPost({ post, isDialogOpen, setIsDialogOpen }: DialogProps) {
  const { showDialogConfirm } = appStore();
  const { token } = useAppSelector((state) => state.auth);
  const [loadingSubmit, setloadingSubmit] = useState<boolean>(false);
  const [hideDescription, setHideDescription] = useState<boolean>(false);
  const [percentag, setPercentag] = useState<any>();

  const submitReportPost = async (id: any) => {
    setloadingSubmit(true);
    try {
      let url: string = "";
      url = RouteApi.submitReportPost;
      url += `token=${token}`;
      const data = {
        post_id: id,
        report_percentage: percentag,
      };
      await RequestApi(url, { data })
        .then((responses) => {
          if (responses.status === "success") {
            setloadingSubmit(false);
            setHideDescription(true);
            // onUploadSuccess({
            //   res: responses.user_shop_product,
            //   name: "delete",
            // });
          }
        })
        .catch((err) => {
          setloadingSubmit(false);
        });
    } catch (error) {
      setloadingSubmit(false);

      AppLog.show({
        message: `[submitReportPost]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const { ReportPost } = Reports();
  const [selectedReport, setSelectedReport] = useState<boolean>(false);
  const [selectedReport2, setSelectedReport2] = useState<boolean>(false);
  const [selectedReport3, setSelectedReport3] = useState<boolean>(false);
  const [reportData, setReportData] = useState<any>();
  const [reportDetail, setReportDetail] = useState<any>();
  const [titile, setTitle] = useState<any>(" Select a reason");

  return (
    <Dialog open={isDialogOpen}>
      <DialogContent
        onWheel={(e) => {
          e.stopPropagation();
        }}
        isShowBtnXClose={false}
        className="max-w-full lg:max-w-[800px] h-[calc(100vh-80px)] py-2 px-0 flex flex-col p-4 "
      >
        <DialogHeader>
          <DialogTitle className=" text-start flex  items-center gap-5">
            <div
              onClick={() => {
                setSelectedReport(false);
                setSelectedReport2(true);
                setSelectedReport3(true);
                setTitle(" Select a reason");
              }}
              className={`
                flex items-center justify-center cursor-pointer rounded-full hover:bg-accent hover:text-accent-foreground w-[36px] h-[36px]`}
            >
              <ArrowLeft />
            </div>
            {titile}
          </DialogTitle>

          <div
            className="absolute flex items-center justify-center right-3 top-1 z-40 cursor-pointer rounded-full hover:bg-accent hover:text-accent-foreground w-[36px] h-[36px] p-2"
            onClick={() => setIsDialogOpen(false)}
          >
            <X />
          </div>
        </DialogHeader>
        <ScrollArea className="mt-2 gap-3  pr-[20px] pb-[50px]">
          {hideDescription ? (
            <>
              <div className="w-full px-4 py-8 ">
                <h1 className="text-xl font-semibold mb-4">Reporting a Post: Help Us Keep the Community Safe</h1>
                <p className="mb-6">
                  We appreciate you taking the time to report this post. Your feedback plays a crucial role in helping us maintain a respectful and welcoming environment for
                  everyone on our platform.
                </p>
                <section className="mb-6">
                  <h2 className="text-xl font-semibold mb-2">Why Reporting Matters</h2>
                  <p>
                    Our goal is to create a space where users feel safe, heard, and respected. While we work hard to prevent harmful content from appearing, we rely on our
                    community to flag posts that may have slipped through. Reporting a post helps us identify and address content that may:
                  </p>
                  <ul className="list-disc list-inside space-y-1">
                    <li>Violate community guidelines</li>
                    <li>Include hate speech, bullying, or harassment</li>
                    <li>Promote violence, self-harm, or illegal activity</li>
                    <li>Spread misinformation or harmful content</li>
                    <li>Contain nudity, graphic imagery, or inappropriate behavior</li>
                  </ul>
                  <p className="mt-2">Your report will be handled with care and confidentiality. The user who posted the content will not be notified that you reported it.</p>
                </section>

                <section className="mb-6">
                  <h2 className="text-xl font-semibold mb-2">What Happens After You Report</h2>
                  <p className="mb-2">Once you submit a report, here’s what you can expect:</p>
                  <ul className=" space-y-1">
                    <li>
                      1. <strong>Review by our moderation team –</strong> Our team carefully reviews the post to determine if it violates our community standards.
                    </li>
                    <li>
                      2. <strong>Action if necessary – </strong>If the content is found to be in violation, we may remove the post, issue warnings, restrict the user’s account, or
                      take other actions as needed.
                    </li>
                    <li>
                      3. <strong>Notification – </strong>In many cases, we’ll let you know the outcome of your report, though for privacy reasons, we may not share specific
                      details.
                    </li>
                  </ul>
                  <p className="mt-2">
                    Please note that not all content that you find offensive or disagree with necessarily breaks our rules. However, every report is taken seriously and reviewed
                    with fairness and attention.
                  </p>
                </section>

                <section className="mb-6">
                  <h2 className="text-xl font-semibold mb-2">False Reporting</h2>
                  <p>We encourage you to use the reporting feature responsibly. Submitting false reports or abusing the system can result in limitations on your account.</p>
                </section>

                <section>
                  <h2 className="text-xl font-semibold mb-2">Thank You for Your Help</h2>
                  <p>
                    By reporting posts that you believe are harmful, inappropriate, or misleading, you’re actively contributing to a better experience for everyone. We truly
                    appreciate your vigilance and support.
                  </p>
                  <p className="mt-2">If you believe a situation requires immediate attention or if you feel unsafe, please contact local authorities or emergency services.</p>
                </section>
              </div>
            </>
          ) : (
            <div>
              {!selectedReport && (
                <div className="  p-4 space-y-4">
                  {ReportPost.map((option: any, index) => (
                    <div
                      key={index}
                      onClick={() => {
                        setSelectedReport2(false);
                        setSelectedReport(true);
                        setReportData(option);
                        setReportData(option);
                        setTitle(option.title);
                      }}
                      className="flex justify-between items-center  pb-2 cursor-pointer"
                    >
                      <span className="text-base">{option.title}</span>
                      <ChevronRight className=" size-6 text-gray-400 dark:text-white" />
                    </div>
                  ))}
                </div>
              )}
              {!selectedReport2 && (
                <div>
                  {reportData?.list ? (
                    <div className=" p-4 space-y-4">
                      {reportData?.list?.map((data: any, index: number) => (
                        <div
                          key={index}
                          onClick={() => {
                            setSelectedReport2(true);
                            setSelectedReport3(false);
                            setReportDetail(data);
                            setTitle(data.title);
                          }}
                          className="flex justify-between items-center pb-2 cursor-pointer"
                        >
                          <span className="text-base">{data.title}</span>
                          <ChevronRight className=" size-6 text-gray-400 dark:text-white" />
                        </div>
                      ))}
                    </div>
                  ) : reportData ? (
                    <div className="  px-4 py-6 space-y-4">
                      {/* Title */}
                      <h1 className="text-xl font-bold leading-tight">{reportData?.title}</h1>
                      {/* Subtitle */}
                      <p className="text-base font-medium">{reportData?.report?.sub}</p>
                      {/* Bullet List */}
                      <ul className="list-disc pl-5 space-y-2 text-sm ">
                        {reportData?.report?.list_des.map((item: any, index: any) => (
                          <li key={index} className="leading-relaxed">
                            {item}
                          </li>
                        ))}
                      </ul>

                      {Service.userAuth.id === 1 && (
                        <>
                          {" "}
                          <label htmlFor="percentag" className="block mb-1 text-xl font-bold leading-tight">
                            Percentage
                          </label>
                          <NumberInput
                            id="percentag"
                            value={percentag}
                            onChange={(e) => {
                              setPercentag(e.target.value);
                            }}
                          />
                        </>
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              )}
              {!selectedReport3 && (
                <div>
                  {reportDetail && (
                    <div className="  px-4 py-6 space-y-4">
                      {/* Title */}
                      <h1 className="text-xl font-bold leading-tight">{reportDetail.title}</h1>

                      {/* Subtitle */}
                      <p className="text-base font-medium">{reportDetail?.report?.sub}</p>

                      {/* Bullet List */}
                      <ul className="list-disc pl-5 space-y-2 text-sm ">
                        {reportDetail.report?.list_des.map((item: any, index: any) => (
                          <li key={index} className="leading-relaxed">
                            {item}
                          </li>
                        ))}
                      </ul>
                      {Service.userAuth.id === 1 && (
                        <>
                          {" "}
                          <label htmlFor="percentag" className="block mb-1 text-xl font-bold leading-tight">
                            Percentage
                          </label>
                          <NumberInput
                            id="percentag"
                            value={percentag}
                            onChange={(e) => {
                              setPercentag(e.target.value);
                            }}
                          />
                        </>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          <ScrollBar orientation="vertical" />
        </ScrollArea>
        {hideDescription ? (
          <div className="flex justify-between gap-3 pr-[20px] items-center px-4 fixed bottom-[10px] left-0 w-full">
            <button
              onClick={() => {
                setIsDialogOpen(false);
              }}
              className="w-full mt-6 bg-red-500 text-white font-semibold text-lg py-2 rounded-lg flex items-center justify-center outline-none focus:border-none"
            >
              Close
            </button>
          </div>
        ) : (
          <div className="flex justify-between gap-3 pr-[20px] items-center px-4 fixed bottom-[10px] left-0 w-full">
            <button
              onClick={() =>
                showDialogConfirm({
                  titileButtonSubmit: "Yes, Report",
                  titileButtonCancel: "No, Cancel",
                  title: "Report",
                  message: "Do you want to Report ?",
                  onSubmit() {
                    submitReportPost(post?.post_id);
                  },
                })
              }
              className="w-full mt-6 bg-yellow-500 text-white font-semibold text-lg py-2 rounded-lg flex items-center justify-center outline-none focus:border-none"
            >
              {loadingSubmit ? <Loader className="animate-spin" /> : "Submit"}
            </button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}

